<template>
    <b-container fluid>
        <b-row>
            <b-col md="6">
                <b-form-group
                    id="fieldset-created_start"
                    label="Start Date"
                    label-for="input-created_start"
                >
                    <b-form-input
                        type="date"
                        id="input-created_start"
                        v-model="model.created_start"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                    id="fieldset-created_end"
                    label="End Date"
                    label-for="input-created_end"
                >
                    <b-form-input
                        type="date"
                        id="input-created_end"
                        v-model="model.created_end"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                    id="input-group-type"
                    label="Type:"
                    label-for="input-type"
                >
                    <b-form-select
                        id="input-type"
                        v-model="model.order_type_id"
                        :options="orderTypes"
                        value-field="id"
                        text-field="name"
                        required
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                    id="fieldset-order_category"
                    label="Service Category"
                    label-for="input-order_category"
                >
                    <b-form-select
                        id="input-order_category"
                        v-model="model.service_category"
                        value-field="id"
                        text-field="name"
                        :options="categories"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data() {
        return {
            model: {
                order_type_id: 0,
                service_category: 0,
                created_start: null,
                created_end: null,
            },
        }
    },
    props: ['value'],

    methods: {
        // Used for passing data from child component to parent
    },

    watch: {
        model: {
            handler: function (_model) {
                this.$emit('input', { ..._model })
            },
            deep: true,
        },
    },
    mounted() {
        // Store ordertypes in vuex store
        this.$store.dispatch('orderType/fetchAll')
        // Store order categories in vuex store
        this.$store.dispatch('requestCategory/fetchAll')
        this.model = { ...this.value }
    },
    computed: {
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
                .filter(x => !!x.is_customer_portal_visible)
                .map(x => ({
                    id: x.id,
                    name: x.customer_portal_name || x.name,
                }))
            console.log('orderTypes', orderTypes)
            return [{ name: 'Any', id: 0 }, ...orderTypes]
        },

        categories() {
            const categories = this.$store.state.requestCategory.categories
            console.log('Order Categories', categories)
            return [{ name: 'Any', id: 0 }, ...categories]
        },
    },
}
</script>